import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";
import { Badge, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Spinner } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import Status from "../../MyComp/UI/form/Status";
import MyInput from "../../MyComp/UI/form/MyInput";
import { createDepartmentAPI, createUnitAPI, listDepartmentAPI, listUnitAPI, updateDepartmentAPI, updateUnitAPI } from "../../api/master/indes";

import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";

import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import DataTable from "../../MyComp/UI/DataTable/Table";
import Table from "../../MyComp/UI/DataTable/Table";
const Department= () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };

  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));

  useEffect(() => {
    getDepartmentList();
  }, []);
  const getDepartmentList = () => {
    setValue("isLoading", true);
    listDepartmentAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data || []);
        } else {
          setData([]);
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };
  const onFormSubmit = () => {
    const body = {
      name: watch("name"),
      status: watch("status")?.value,
      ...(mode === "Edit" && { id: watch("selectedRow")?.id }),
    };

    setValue("isLoading", true);

    if (mode === "Add") {
      createDepartmentAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);

            getDepartmentList();
            setIsOpen(false);
            resetF();
          } else if (res.data.status === "expired") {
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message))
        .finally(() => setValue("isLoading", false));
    }

    if (mode === "Edit") {
      updateDepartmentAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);

            getDepartmentList();
            setIsOpen(false);
            resetF();
          } else if (res.data.status === "expired") {
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message))
        .finally(() => setValue("isLoading", false));
    }
  };
 

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("name", row?.name);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateDepartmentAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getDepartmentList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const resetF = () => {
    setValue("name", null);
    setValue("status", "");
    setMode("Add");
  };
  return (
    <>
      <Head title={"Department | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Department </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Name"}
                            name={"name"}
                            placeholder={"Enter name"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Department List"
            data={data}
            publicButton={false}
            columns={[{ key: "name", label: "Name" }]}
            searchKeys={["name"]}
            nameColumn={"name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Department;
